
  import { MODAL_LIST_DATA } from '@/constants/modals';

  export default {
    props: {
      articleEmbed: { type: Boolean, default: false },
      bundle: { type: Object, required: true },
      isStaffPick: { type: Boolean, default: false }
    },
    computed: {
      applyPath () {
        const basePath = `/compare-tv-broadband-phone/apply/${this.pathParams.join('/')}/`;
        return this.isStaffPick ? `${basePath}sp/` : basePath;
      },
      discount () {
        const discountAmount = this.bundle.nondiscounted_annual_cost - this.bundle.cost_annual;
        return discountAmount > 0 ? this.$t('summary.discount', { amount: this.$n(discountAmount, 'currencyRound') }) : null;
      },
      exclusive () {
        return this.bundle.exclusive;
      },
      hasDiscount () {
        return this.bundle.discount_tiers && this.bundle.discount_tiers.length >= 1;
      },
      onProviderPage () {
        return !this.$route.path.includes('your-results');
      },
      pathParams () {
        return [this.bundle.institution.slug, this.bundle.code, this.bundle.slug];
      },
      showPath () {
        const basePath = `/compare-tv-broadband-phone/${this.pathParams.join('/')}/`;
        return this.isStaffPick ? `${basePath}sp/` : basePath;
      }
    },
    methods: {
      showChannels () {
        this.$store.commit('modal/PUSH_MODAL', { id: MODAL_LIST_DATA.DIGITAL_CHANNELS, settings: this.bundle });
      }
    }
  };
